
export const SET_MSG = 'FOLHAR_MSG';
export const SET_EDITAR = 'FOLHAR_EDITAR';
export const SET_LISTA = 'FOLHAR_EDITAR';
export const SET_PESQUISA = 'FOLHAR_PESQUISA';
export const SET_TRABALHADOR = 'FOLHAR_TRABALHADOR';